import { Link } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/fr";
import { getEmployeCin } from "../../../../services/RHService/ContractService";
import {
  getCrews,
  getEmployeeWithNoCrew,
  affectEmployeeToCrew,
  updateCrew,
  deleteCrew,
} from "../../../../services/RHService/CrewService";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";

const CrewList = ({ startLoading, stopLoading }) => {
  //variables
  const { ExportCSVButton } = CSVExport;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModifyform, setShowModifyform] = useState(false);
  const handleCloseModifyform = () => setShowModifyform(false);
  const [events, setEvents] = useState([]);
  moment.locale("fr");
  const [crewNames, setCrewNames] = useState([]);
  const [employeesNames, setEmployeesNames] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [selectedEmployeeCin, setSelectedEmployeeCin] = useState("");
  const [selectedCrew, setSelectedCrew] = useState([]);
  const [employeeError, setEmployeeError] = useState("");
  const [crewError, setCrewError] = useState("");
  //Afficher les equipe dans la select box (Affecter un personnel a une équipe) et dans le tableau

  const fetchCrewNames = async () => {
    try {
      startLoading()
      const response = await getCrews(getCurrentUserId());

      if (response.data?.success) {
        setCrewNames(response.data?.success);
      } else if (response.error) {
        throw new Error(response.error);
      }
    } catch (error) {
      console.error(`Failed to fetch crew names: ${error}`);
    } finally {
      stopLoading()
    }
  };
  useEffect(() => {
    fetchCrewNames();
  }, []);
  //Afficher les employees qui n'ont pas encore une equipe
  useEffect(() => {
    const fetchEmployeeNames = async () => {
      try {
        const response = await getEmployeeWithNoCrew(getCurrentUserId());

        if (response.data?.success) {
          setEmployeesNames(response.data?.success);
          console.log(response);
        } else if (response.error) {
          throw new Error(response.error);
        }
      } catch (error) {
        console.error(`Failed to fetch crew names: ${error}`);
      }
    };
    fetchEmployeeNames();
  }, []);

  const handleInputChange = async (event) => {
    try {
      const target = event.target;
      const name = target.name;
      const value = target.type === "checkbox" ? target.checked : target.value;
      setFormData({ ...formData, [name]: value });
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    setSelectedEmployeeId(formData.idEmployee);
  }, [formData]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedEmployeeId !== "empl") {
          const cin = await getEmployeCin(selectedEmployeeId);
          setSelectedEmployeeCin(cin.data?.success);
        } else {
          setSelectedEmployeeCin("");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [selectedEmployeeId, formData.idEmployee]);
  //Affecter un employee a une equipe
  const handleSubmit = async (event) => {
    event.preventDefault();

    const { idEmployee, idEquipe } = formData;
    let hasError = false;

    if (!idEmployee || idEmployee === "empl") {
      setEmployeeError("Veuillez saisir un Personnel.");
      hasError = true;
    } else {
      setEmployeeError("");
    }

    if (!idEquipe || idEquipe === "equipe") {
      setCrewError("Veuillez saisir une équipe.");
      hasError = true;
    } else {
      setCrewError("");
    }
    if (!hasError) {
      try {
        await affectEmployeeToCrew(getCurrentUserId(), formData);
        handleClose();
        toastr.success("Personnel affecté avec succès.");
      } catch (error) {
        toastr.error("Erreur lors de l'affectation.");
      }
    }
  };
  //convertir les jrs /mois en français
  const frenchLocalizer = momentLocalizer(moment, {
    formats: {
      timeGutterFormat: "H:mm",
      dayFormat: "dddd D",
      dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
        `${localizer.format(start, "D MMMM", culture)} — ${localizer.format(
          end,
          "D MMMM",
          culture
        )}`,
      monthHeaderFormat: "MMMM YYYY",
      agendaHeaderFormat: ({ start, end }, culture, localizer) =>
        `${localizer.format(start, "D MMMM", culture)} — ${localizer.format(
          end,
          "D MMMM",
          culture
        )}`,
      agendaDateFormat: "dddd D MMMM YYYY",
      agendaTimeFormat: "H:mm",
      agendaTimeRangeFormat: ({ start, end }, culture, localizer) =>
        `${localizer.format(start, "H:mm", culture)} — ${localizer.format(
          end,
          "H:mm",
          culture
        )}`,
    },
    months: moment.localeData().months(),
    weekdaysShort: moment.localeData().weekdaysShort(),
    weekdaysLong: moment.localeData().weekdays(),
    firstDayOfWeek: moment.localeData().firstDayOfWeek(),
  });
  //translate the calendar to frensh
  const messages = {
    allDay: "Toute la journée",
    previous: "Précédent",
    next: "Suivant",
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    agenda: "Agenda",
    date: "Date",
    time: "Heure",
    event: "Événement",
    noEventsInRange: "Aucun événement à afficher",
  };
  //events calendar
  const fetchPlannings = useCallback(async () => {
    try {
      const formattedPlannings = crewNames.map((planning) => ({
        title: crewNames.find((crew) => crew.idEquipe === planning.idEquipe)
          ?.nomEquipe, // get the crew name from the crewNames state
        start: new Date(planning.dateDeb),
        end: new Date(planning.dateFin),
      }));
      //   console.log(formattedPlannings);
      setEvents(formattedPlannings);
    } catch (error) {
      console.error(`Failed to fetch plannings: ${error}`);
    }
  }, [crewNames]);

  useEffect(() => {
    fetchPlannings();
  }, [fetchPlannings, getCrews]);
  //afficher les information a modifier par defaut dans le Model
  const handleShowModifyform = (crew) => {
    setSelectedCrew(crew);
    setShowModifyform(true);
  };
  //colonnes de tableau
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    { dataField: "nomEquipe", text: "Equipe" },
    {
      dataField: "chefEquipe",
      text: "Chef d'équipe",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    {
      dataField: "dateDeb",
      text: "Date début",
      formatter: (cell, row) => {
        return (
          <div style={{ textAlign: "center" }}>
            {row.dateDeb && cell}
            {!row.dateDeb && "-"}
          </div>
        );
      },
    },
    {
      dataField: "dateFin",
      text: "Date fin",
      formatter: (cell, row) => {
        return (
          <div style={{ textAlign: "center" }}>
            {row.dateFin && cell}
            {!row.dateFin && "-"}
          </div>
        );
      },
    },
    {
      dataField: "heureDeb",
      text: "Heure début",
      formatter: (cell, row) => {
        return (
          <div style={{ textAlign: "center" }}>
            {row.heureDeb && cell}
            {!row.heureDeb && "-"}
          </div>
        );
      },
    },
    {
      dataField: "heureFin",
      text: "Heure fin",
      formatter: (cell, row) => {
        return (
          <div style={{ textAlign: "center" }}>
            {row.heureFin && cell}
            {!row.heureFin && "-"}
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerStyle: { width: "170px" },
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShowModifyform(row);
              }}
            >
              <i className="fa-solid fa-pencil"></i>
            </Button>
            <Link to={`/employee_by_crew?idEquipe=${row.idEquipe}`}>
              <Button
                className="mx-1"
                style={{
                  "background-color": "#696969",
                  color: "white",
                  "border-color": "transparent",
                  "border-radius": "0px",
                }}
              >
                <i
                  class="fa-solid fa-eye eye-icon m-1"
                  style={{ color: "white" }}
                ></i>
              </Button>
            </Link>
            <Button
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.idEquipe);
              }}
            >
              <i className="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  //pagination options
  const paginationoptions = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  // Update
  const handleUpdate = async (event) => {
    event.preventDefault();

    // Convert date format to "YYYY-MM-DD"
    const { dateDeb, dateFin, ...otherFormData } = selectedCrew;
    const formattedFormData = {
      ...otherFormData,
      dateDeb: moment(selectedCrew.dateDeb).format("YYYY-MM-DD"),
      dateFin: moment(selectedCrew.dateFin).format("YYYY-MM-DD"),
    };

    const debDate = new Date(formattedFormData.dateDeb);
    const finDate = new Date(formattedFormData.dateFin);

    if (debDate >= finDate) {
      toastr.error("La date de début doit être antérieure à la date de fin.");

      return;
    }

    try {
      await updateCrew(formattedFormData.idEquipe, formattedFormData);
      fetchCrewNames();
      handleCloseModifyform();
    } catch (error) {
      alert(error.message);
    }
  };
  // delete
  const handleDelete = async (crewId) => {
    await deleteCrew(crewId, setCrewNames);
  };
  // Filtrage par equipe
  const [filterData, setFilterData] = useState({});
  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setFilterData({
      ...filterData,
      [name]: value,
    });
  };
  const filteredData = crewNames.filter((contrat) => {
    const idEquipe = contrat.idEquipe.toString();

    if (
      filterData.idEquipe &&
      idEquipe !== filterData.idEquipe &&
      filterData.idEquipe !== "equipe"
    ) {
      return false;
    }
    return true;
  });

  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={filteredData}
        columns={columns}
        exportCSV={{
          fileName: "List Equipes.csv",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(props) => (
          <div>
            {/* Modify Crew Modal */}
            <Modal
              show={showModifyform}
              onHide={handleCloseModifyform}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Nom d'équipe</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Nom d'équipe"
                            autoFocus
                            name="nomEquipe"
                            value={selectedCrew ? selectedCrew.nomEquipe : ""}
                            onChange={(e) =>
                              setSelectedCrew({
                                ...selectedCrew,
                                nomEquipe: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <div className="form-group">
                          <label>Chef d'equipe </label>
                          <select
                            className="custom-select form-control-border"
                            name="idChefEquipe"
                            value={
                              selectedCrew ? selectedCrew.idChefEquipe : ""
                            }
                            onChange={(e) =>
                              setSelectedCrew({
                                ...selectedCrew,
                                idChefEquipe: e.target.value,
                              })
                            }
                          >
                            <option
                              value=""
                              selected
                              defaultValue={
                                selectedCrew ? selectedCrew.idChefEquipe : ""
                              }
                            >
                              {selectedCrew
                                ? selectedCrew.firstname +
                                " " +
                                selectedCrew.lastname
                                : ""}
                            </option>
                            {employeesNames.map((employeesName) => (
                              <option
                                key={employeesName.id}
                                value={employeesName.id}
                              >
                                {employeesName.firstName}{" "}
                                {employeesName.lastName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label>Date début</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateDeb"
                              value={selectedCrew ? selectedCrew.dateDeb : ""}
                              onChange={(e) =>
                                setSelectedCrew({
                                  ...selectedCrew,
                                  dateDeb: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              max="2100-12-31"
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Date fin</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateFin"
                              value={selectedCrew ? selectedCrew.dateFin : ""}
                              onChange={(e) =>
                                setSelectedCrew({
                                  ...selectedCrew,
                                  dateFin: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              max="2100-12-31"
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div class="form-group">
                          <label>Heure début</label>
                          <div
                            class="input-group date"
                            id="reservationdatetime"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control form-control-border
                                                             datetimepicker-input"
                              type="time"
                              id="appt"
                              name="heureDeb"
                              value={selectedCrew ? selectedCrew.heureDeb : ""}
                              onChange={(e) =>
                                setSelectedCrew({
                                  ...selectedCrew,
                                  heureDeb: e.target.value,
                                })
                              }
                              min="09:00"
                              max="18:00"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Heure fin</label>
                          <div
                            class="input-group date"
                            id="reservationdatetime"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control form-control-border "
                              type="time"
                              id="appt"
                              name="heureFin"
                              value={selectedCrew ? selectedCrew.heureFin : ""}
                              onChange={(e) =>
                                setSelectedCrew({
                                  ...selectedCrew,
                                  heureFin: e.target.value,
                                })
                              }
                              min="09:00"
                              max="18:00"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModifyform}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modify Crew Modal */}

            {/* Modal d'affectation d'un personnel a une equipe */}
            <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Affecter un personnel a une équipe</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleSubmit}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <label htmlFor="exampleSelectBorder">Equipe </label>
                          <select
                            className="custom-select form-control-border"
                            name="idEquipe"
                            value={formData.idEquipe}
                            onChange={handleInputChange}
                          >
                            <option value="equipe">
                              --Choisir une equipe--
                            </option>
                            {crewNames.map((crewName) => (
                              <option
                                key={crewName.idEquipe}
                                value={crewName.idEquipe}
                              >
                                {crewName.nomEquipe}
                              </option>
                            ))}
                          </select>
                        </div>
                        {crewError && (
                          <p style={{ color: "red" }}>{crewError}</p>
                        )}

                        <Row>
                          <Col xs={6} md={6}>
                            <div className="form-group">
                              <select
                                className="custom-select form-control-border"
                                name="idEmployee"
                                value={formData.idEmployee}
                                onChange={handleInputChange}
                              >
                                <option value="empl">
                                  --Choisir un employee--
                                </option>
                                {employeesNames.map((employeesName) => (
                                  <option
                                    key={employeesName.id}
                                    value={employeesName.id}
                                  >
                                    {employeesName.firstName}{" "}
                                    {employeesName.lastName}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {employeeError && (
                              <p style={{ color: "red" }}>{employeeError}</p>
                            )}
                          </Col>
                          <Col xs={6} md={6}>
                            {selectedEmployeeCin && (
                              <button
                                type="button"
                                class="btn btn-block btn-default"
                              >
                                {selectedEmployeeCin}
                              </button>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleSubmit}>
                  Affecter
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modal d'affectation d'un personnel a une equipe */}
            <br />
            <section className="content ">
              <div class="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <h5 class="card-title">Ajouter une équipe</h5>

                    <Link to="/addCrew">
                      <button class="btn btn-dark  float-right">
                        <i class="fas fa-plus"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </section>
            <section className="content ">
              <div class="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <h5 class="card-title">
                      Affecter un personnel à une équipe
                    </h5>

                    {/* <Link to="/addCrew" > */}
                    <button
                      class="btn btn-dark float-right"
                      onClick={handleShow}
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            </section>

            <div class="container-fluid">
              <div class="row">
                <div className="col-md-2 col-lg-2 col-sm-12 mb-2">
                  <ExportCSVButton
                    {...props.csvProps}
                    className="btn btn1 float-left"
                  >
                    Export CSV
                  </ExportCSVButton>
                </div>

                {/* Affectation d'un personnel a une equipe */}
                {/* <div className="col-md-3 col-lg-3 col-sm-12 mb-2">
                  <button
                    type="button"
                    style={{ width: "max-content", color: "white" }}
                    onClick={handleShow}
                    className="btn btn-default bg2 float-left"
                  >
                    Affecter un personnel à une équipe
                  </button>
                </div> */}
                <div className="col-md-2 col-lg-2 col-sm-12 mb-2 float-right">
                  {/* filter by crew name */}
                  <Form.Group controlId="exampleForm.ControlSelect1 float-right">
                    <select
                      className="custom-select form-control-border"
                      name="idEquipe"
                      value={filterData.idEquipe}
                      onChange={handleChange}
                    >
                      <option value="equipe">--Filtrer par equipe--</option>
                      {crewNames.map((crewName) => (
                        <option
                          key={crewName.idEquipe}
                          value={crewName.idEquipe}
                        >
                          {crewName.nomEquipe}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                  {/* filter by crew name */}
                </div>
                {/* buttons */}
                <div className="col-md-3 col-lg-3 col-sm-12  mb-2 float-right">
                  <Link to="/time_planing">
                    {" "}
                    <button
                      type="button"
                      style={{ width: "-webkit-fill-available" }}
                      className="btn btn-default float-left"
                    >
                      Planification de temps
                    </button>
                  </Link>
                </div>
                {/* <div className="col-md-2 col-lg-2 col-sm-12 mb-2 float-right">
                  <Link to="/addCrew">
                    {" "}
                    <button type="button" className="btn btn-dark float-right">
                      Ajouter une équipe
                    </button>
                  </Link>
                </div> */}

                <div class="col-md-12">
                  <div class="card">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="card-header col-md-12 ">
                          <ul class="nav nav-pills ml-auto p-2 float-right">
                            <li class="nav-item">
                              <a
                                class="nav-link active mycolorhoverclass"
                                href="#table"
                                data-toggle="tab"
                              >
                                <i class="fa-solid fa-table mx-1"></i>Tableau
                              </a>
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link  mycolorhoverclass"
                                href="#calendar"
                                data-toggle="tab"
                              >
                                <i class="fa-regular fa-calendar-days mx-1"></i>
                                Calendrier
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      {/* table */}
                      <div class="tab-content">
                        <div class="tab-pane active" id="table">
                          <BootstrapTable
                            {...props.baseProps}
                            data={filteredData}
                            columns={columns}
                            pagination={paginationFactory(paginationoptions)}
                          />
                        </div>
                        <div class="tab-pane" id="calendar">
                          <Calendar
                            localizer={frenchLocalizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            messages={messages}
                            style={{ height: 500 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default withLoader(CrewList);
